import { CircularProgress, CircularProgressProps } from '@mui/material';
import React from 'react';

export function LoadingSpinner({ size = 10, ...props }: CircularProgressProps) {
  return <CircularProgress size={size} {...props} />;
}
